import {
  useState,
  useEffect,
} from "react";

import RoleSelector from "components/Player/RoleSelector";
import ModalWrapper from "components/Wrappers/ModalWrapper";

import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";
import PillButton from "components/General/PillButton";

export default function PlayersMenu() {
  const { socket, playerId } = useWebSocket();
  const {
    isAdmin,
    hostId,
    players,
    connectedIds,
    gameStarted
  } = useGameContext() as any;

  const removePlayer = (player: any) => {
    if (hostId === player.id) {
      const mes = JSON.stringify({
        kind: "RemoveHostFromPlaying",
        toIds: connectedIds,
        playerId: player.id,
      })

      socket?.send( mes );
      return
    }
    const mes = JSON.stringify({
      kind: "Die",
      toIds: [player.id],
    })

    socket?.send( mes );
  }

  const [openRoleChangeModal, setOpenRoleChangeModal] = useState(false);
  const [pIdToEdit, setPIdToEdit]  = useState(0);

  function submitEditPlayer(playerId: number, ne: string, nr: string) {
    const mes = JSON.stringify({
      kind: "UpdatePlayerInfo",
      toIds: connectedIds,
      playerId: playerId,
      newData: {
        estate: ne,
        role: nr,
      }
    })
    socket?.send( mes );
  }

  return (
    <div className="h-full w-full flex flex-col p-2 gap-2">
      <label className="text-center w-full">Players</label>

      <div className="grid grid-cols-6 gap-4 items-center">
        { isAdmin && (
          <p>Remove</p>
        )}
        { (isAdmin && !gameStarted) && (
          <p>Edit</p>
        )}
        <p>Name</p>
        <p>Id</p>
        <p>Estate</p>
        <p>Role</p>
      </div>

      { players.map((player: any, i: number) => {
        return (
          <div key={i} className="grid grid-cols-6 gap-4 items-center">
            { isAdmin && (
              player?.id === playerId && gameStarted ? (
                <>{"_"}</>
              ) : (
                <div className="w-7">
                  <PillButton
                    onClick={() => removePlayer(player)}
                    text={"x"}
                  />
                </div>
              )
            )}
            { (isAdmin && !gameStarted) && (
              <div className="w-7">
                <PillButton
                  onClick={() => {
                    setPIdToEdit(player?.id);
                    setOpenRoleChangeModal(true)
                  }}
                  text={"𝚫"}
                />
              </div>
            )}
            <p>{player?.playerName}</p>
            <p>{player?.id}</p>
            <p>{player?.estate}</p>
            <p>{player?.role}</p>
            <p>{player?.status}</p>
          </div>
        )
      })}


      <ModalWrapper open={openRoleChangeModal} setOpen={setOpenRoleChangeModal}>
        <h1 className="text-xl">Change player role</h1>
        <RoleSelector
          customSelectRole={(e, r) => {
            submitEditPlayer(pIdToEdit, e, r);
            setOpenRoleChangeModal(false);
            return;
          }}
        />
      </ModalWrapper>
    </div>
  )
}
